import { TypeInteraction } from "domain/entities/type-interaction";
import { Result } from "domain/entities/result";
import { TypeInteractionRepository } from "domain/repositories";

export default class UpdateUseCase {
    private typeInteractionRepository: TypeInteractionRepository;
    
    public constructor(typeInteractionRepository: TypeInteractionRepository) {
        this.typeInteractionRepository = typeInteractionRepository
    }

    public async updateTypeInteraction(id: number, typeInteraction: TypeInteraction, token: Promise<[string | null, string | null]>): Promise<[Result, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.typeInteractionRepository.updateTypeInteraction(id, typeInteraction, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}